import React, { FC } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { useWindowSize } from "go-core/components/useWindowSize";
import { StocktakingSummaryApi } from "../../../../../../../../services/Api/Organization/types";

interface Props {
	summary: StocktakingSummaryApi;
}

const StocktakingSummary: FC<Props> = ({ summary }) => {
	const { t } = useTranslation();
	const isMobile = useWindowSize().isMobile;

	return (
		<div className="row mb-4" style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}>
			<div className="col-md-4 mb-2">
				<Card>
					<Card.Body>
						<h5 className="mb-1">{t("common.word.actual_price_money")}</h5>
						<h4 className="text-primary mb-0">{FormatMoney(summary.total_amount_after_money)}</h4>
					</Card.Body>
				</Card>
			</div>
			<div className="col-md-4 mb-2">
				<Card>
					<Card.Body>
						<h5 className="mb-1">{t("modules.stocktaking.field.total_amount_plus_money.title")}</h5>
						<h4 className="text-primary mb-0">{FormatMoney(summary.total_amount_plus_money)}</h4>
					</Card.Body>
				</Card>
			</div>
			<div className="col-md-4 mb-2">
				<Card>
					<Card.Body>
						<h5 className="mb-1">{t("modules.stocktaking.field.total_amount_minus_money.title")}</h5>
						<h4 className="text-primary mb-0">{FormatMoney(summary.total_amount_minus_money)}</h4>
					</Card.Body>
				</Card>
			</div>
		</div>
	);
};

export default StocktakingSummary;
